import {
  Button,
  Flex,
  HStack,
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import { ConfigDomain } from 'domain/configs/config.types';
import { DOMAIN_LABELS } from 'domain/configs/domain-labels';
import { FaChevronDown } from 'react-icons/fa6';
import { IoCloseCircle, IoSearchOutline } from 'react-icons/io5';

interface FiltersHeaderProps {
  search: string;
  setSearch(s: string): void;
  isToken: boolean;
  setIsToken(b: boolean): void;
  isBoolean: boolean;
  setIsBoolean(b: boolean): void;
  isActive: boolean;
  setIsActive(b: boolean): void;
  isNotActive: boolean;
  setIsNotActive(b: boolean): void;
  domain?: ConfigDomain;
  setDomain(c?: ConfigDomain): void;
}

const FiltersHeader: React.FC<FiltersHeaderProps> = ({
  search,
  setSearch,
  isToken,
  setIsToken,
  isActive,
  setIsActive,
  isBoolean,
  setIsBoolean,
  isNotActive,
  setIsNotActive,
  domain,
  setDomain: setDomainFromProps,
}) => {
  const setDomain = (d?: ConfigDomain) => {
    if (!d || d === domain) return setDomainFromProps(undefined);
    setDomainFromProps(d);
  };

  return (
    <Flex direction="column" gap="1rem">
      <InputGroup maxW="40em">
        <Input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Pesquisar por nome ou descrição..."
        />
        <InputRightElement>
          {!search ? (
            <Icon aria-label="pesquisar" as={IoSearchOutline} />
          ) : (
            <IconButton
              aria-label="Limpar busca"
              variant="link"
              icon={<IoCloseCircle />}
              onClick={() => setSearch('')}
            />
          )}
        </InputRightElement>
      </InputGroup>

      <HStack flexWrap={{ base: 'wrap', md: 'nowrap' }}>
        <Button
          variant="outline"
          fontWeight="400"
          colorScheme={
            !isToken && !isBoolean && !isActive && !isNotActive && !domain
              ? 'yooga'
              : 'gray'
          }
          onClick={() => {
            setIsToken(false);
            setIsBoolean(false);
            setIsActive(false);
            setIsNotActive(false);
            setDomain();
          }}
        >
          Todos
        </Button>
        <Button
          variant="outline"
          fontWeight="400"
          colorScheme={isToken ? 'yooga' : 'gray'}
          onClick={() => {
            setIsToken(!isToken);
            setIsBoolean(false);
          }}
        >
          Valor manual
        </Button>
        <Button
          variant="outline"
          fontWeight="400"
          colorScheme={isBoolean ? 'yooga' : 'gray'}
          onClick={() => {
            setIsBoolean(!isBoolean);
            setIsToken(false);
          }}
        >
          Botão habilitar
        </Button>
        <Button
          variant="outline"
          fontWeight="400"
          colorScheme={isActive ? 'yooga' : 'gray'}
          onClick={() => {
            setIsActive(!isActive);
            setIsNotActive(false);
          }}
        >
          Ativado
        </Button>
        <Button
          variant="outline"
          fontWeight="400"
          colorScheme={isNotActive ? 'yooga' : 'gray'}
          onClick={() => {
            setIsNotActive(!isNotActive);
            setIsActive(false);
          }}
        >
          Desativado
        </Button>

        <Menu>
          <MenuButton
            variant="outline"
            fontWeight="400"
            colorScheme={domain ? 'yooga' : 'gray'}
            as={Button}
            rightIcon={<FaChevronDown />}
          >
            {domain ? DOMAIN_LABELS[domain] : 'Categoria'}
          </MenuButton>
          <MenuList>
            <MenuItem
              bg={domain === 'ADQUIRENCIA' ? 'yooga.100' : 'white'}
              onClick={() => setDomain('ADQUIRENCIA')}
            >
              Adquirência
            </MenuItem>
            <MenuItem
              bg={domain === 'DELIVERY' ? 'yooga.100' : 'white'}
              onClick={() => setDomain('DELIVERY')}
            >
              Delivery
            </MenuItem>
            <MenuItem
              bg={domain === 'FINANCEIRO' ? 'yooga.100' : 'white'}
              onClick={() => setDomain('FINANCEIRO')}
            >
              Financeiro
            </MenuItem>
            <MenuItem
              bg={domain === 'FISCAL' ? 'yooga.100' : 'white'}
              onClick={() => setDomain('FISCAL')}
            >
              Fiscal
            </MenuItem>
            <MenuItem
              bg={domain === 'IMPRESSAO' ? 'yooga.100' : 'white'}
              onClick={() => setDomain('IMPRESSAO')}
            >
              Impressão
            </MenuItem>
            <MenuItem
              bg={domain === 'PDV' ? 'yooga.100' : 'white'}
              onClick={() => setDomain('PDV')}
            >
              Pdv
            </MenuItem>
            <MenuItem
              bg={domain === 'RELATORIO' ? 'yooga.100' : 'white'}
              onClick={() => setDomain('RELATORIO')}
            >
              Relatórios
            </MenuItem>
          </MenuList>
        </Menu>
      </HStack>
    </Flex>
  );
};

export default FiltersHeader;
